export const WHATSAPP_NUMBER = "5549991894679";
export const WHATSAPP_DEFAULT_MSG = "Olá Tales, quero testar o agente de WhatsApp";
export const waLink = (msg = WHATSAPP_DEFAULT_MSG) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;
export const WHATSAPP_LINK = waLink();
export const PHONE_NUMBER = "+5549991894679";
export const TEL_LINK = `tel:${PHONE_NUMBER}`;
export const BRAND = "DEGASPERIN IA";
export const AUTHOR = "por Tales Degasperin";
